import React from "react";
export const Grid = (props) => {
    return React.createElement("div", { className: 'ms-Grid' }, props.children);
};
